import React from "react";
import "../Home/Home.css";
// import "../Footer/Footer.css";
import { NavDropdown } from "react-bootstrap";
import Kaamvalalogo from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/LogoKaamvala.svg";
import { IoLocationSharp } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import facebook from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/ic-facebook.svg";
import linkedIn from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/ic-linked-in.svg";
import twitter from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/ic-twitter.svg";
import youtube from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/ic-skype_footer.svg";
import instagram from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala//ic-instagram.svg";
import { Link, useNavigate } from "react-router-dom";
const Footer = () => {
  const navigate = useNavigate();
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleNavItemClick = (path) => {
    return (e) => {
      e.preventDefault();
      scrollToTop();
      setTimeout(() => navigate(path), 100);
    };
  };

  return (
    <div>
      <footer className="footer-wrapper py-4">
        <div className="container">
          <div className="row justify-content-between">
            {/* Left Side - Logo & Text */}
            <div className="col-md-4">
              <img
                src={Kaamvalalogo}
                alt="kaamvala logo"
                className="img-fluid mb-3"
                width={220}
              />
              <p className="footer-text">
                Your Hard Work, Our Respect, Towards a Better Future, Where
                Every Job is Valued, and Employers Gain Trust.
              </p>
              <p className="footer-text">
                आपकी मेहनत, हमारा सम्मान, एक बेहतर भविष्य की ओर, जहां हर काम की
                होती है कदर, और नियोक्ता को मिलता है विश्वास।
              </p>
              <div className="d-flex gap-3 mt-3">
                <Link to="https://www.facebook.com/people/Kaamvala/61555515489018/">
                  <img src={facebook} alt="facebook" className="footer-icon" />
                </Link>
                <Link to="https://www.linkedin.com/company/kaamvala/">
                  <img src={linkedIn} alt="linkedin" className="footer-icon" />
                </Link>
                <Link to="#">
                  <img src={youtube} alt="youtube" className="footer-icon" />
                </Link>
                <Link to="https://x.com/kaamvala">
                  <img src={twitter} alt="x" className="footer-icon" />
                </Link>
                <Link to="https://www.instagram.com/kaamvala2024/">
                  <img
                    src={instagram}
                    alt="instagram"
                    className="footer-icon"
                  />
                </Link>
              </div>
            </div>

            {/* Center - User Links */}
            <div className="col-md-3">
              <h5 className="footer-heading">User Links</h5>
              <ul className="list-unstyled mt-3 footer-links">
                <li>
                  <Link to="/" onClick={handleNavItemClick("/]")}>
                    Home
                  </Link>
                </li>
                <li
                  className="meri-list"
                  style={{
                    marginLeft: "-13px",
                  }}
                >
                  <NavDropdown
                    title={<>Employer</>}
                    id="employer-dropdown"
                    className="items-hover"
                    renderMenuOnMount={true}
                  >
                    <NavDropdown.Item
                      as={Link}
                      to="/post-job"
                      onClick={handleNavItemClick("/post-job")}
                    >
                      Start Hiring
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      as={Link}
                      to="/price-detail"
                      onClick={handleNavItemClick("/price-detail")}
                    >
                      Price Detail
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      as={Link}
                      to="/policy"
                      onClick={handleNavItemClick("/policy")}
                    >
                      Refund Policy
                    </NavDropdown.Item>
                  </NavDropdown>
                  <NavDropdown
                    title={<>Company</>}
                    id="company-dropdown"
                    className="items-hover"
                    renderMenuOnMount={true}
                  >
                    <NavDropdown.Item
                      as={Link}
                      to="/culture"
                      onClick={handleNavItemClick("/culture")}
                    >
                      Culture Pages
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      as={Link}
                      to="/about-us"
                      onClick={handleNavItemClick("/about-us")}
                    >
                      About Us
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      as={Link}
                      to="/contact"
                      onClick={handleNavItemClick("/contact")}
                    >
                      Contact Us
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      as={Link}
                      to="/fqa"
                      onClick={handleNavItemClick("/fqa")}
                    >
                      FAQ
                    </NavDropdown.Item>
                  </NavDropdown>
                </li>
              </ul>
            </div>
            {/* Right - Contact Info */}
            <div className="col-md-4">
              <h5 className="footer-heading">Get in Touch</h5>
              <ul className="list-unstyled mt-3 contact-info">
                <li className="li-list">
                  <IoLocationSharp className="footer-contact-icon" />
                  7th Floor, TOWER-C, Noida One, Unit C-720, Plot No. 8, Block
                  B, Noida, Uttar Pradesh 201309
                </li>
                <li className="li-list">
                  <MdEmail className="footer-contact-icon" />
                  info@kaamvala.com
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      <div className="full_footer container-fluid text-center py-4">
        <div className="w-100 text-center">
          <p className="text-center">
            © 2025 Kaamvala Agency. All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  );
};
export default Footer;
